export default __webpack_public_path__ + "static/media/10.f798b027.png";